module.exports = __webpack_public_path__ + "img/home.51a429d7.svg";